import React from "react";
import PropTypes from "prop-types";
import ReviewStars from "../ReviewStars";
import AccessionRow from "./AccessionRow";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import CnvLink from "../TooltipActions/CnvLink";
import StructuralVariant from "../../../../models/StructuralVariant";
import Accession from "../../../../models/Accession";

function ClinvarModal({ clinvarInformation, cnv }) {
  const thClass = "tw-p-1 tw-border tw-border-blueGray-200 tw-text-left";
  const {
    review_stars: stars,
    review_status: status,
    num_submitters: submiterCount,
    last_evaluation: lastEvaluation,
    accessions: accessionArr,
    variation_id: variationId,
    type,
  } = clinvarInformation;

  const significanceArr = (clinvarInformation.clinical_significance || [])
    .map((x) => x.toLowerCase())
    .map((x) => ({ value: x, color: getPathogenicityColorByAllNames(x) }));

  const accessions = accessionArr.filter(Boolean).map((x) => new Accession(x));

  return (
    <div className="tw-px-6 tw-text-blueGray-600 tw-my-6 tw-text-xs">
      <div className="tooltip-row tw-items-center tw-text-xs">
        <CnvLink item={cnv} />
      </div>

      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">Clinical Significance:</div>
        {significanceArr.map(({ value, color }, i) => (
          <div
            className="tw-flex tw-items-center"
            key={`${new Date().getTime()}-${i}`}
          >
            <div>{value}</div>
            <div className="tw-w-2" />
            <div
              className="tw-w-2 tw-h-2 tw-rounded-full"
              style={{ backgroundColor: color }}
            />
            <div className="tw-w-2" />
          </div>
        ))}
      </div>

      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">CNV Type:</div>
        <div>{type}</div>
      </div>

      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">Review status:</div>
        <div>{status}</div>
        <div className="tw-px-1">
          <ReviewStars stars={stars} />
        </div>
      </div>

      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">Last Evaluation:</div>
        <div>{lastEvaluation}</div>
      </div>

      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">No. of Submitters:</div>
        <div>{submiterCount}</div>
      </div>

      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">View on ClinVar:</div>
        <div>
          <a
            className="tw-text-bold tw-inline-flex"
            href={`https://www.ncbi.nlm.nih.gov/clinvar/variation/${variationId}`}
            target="_blank"
          >
            Open ClinVar
          </a>
        </div>
      </div>

      <div>
        <div className="tw-text-left tw-mt-6 tw-text-sm tw-font-bold">
          Accessions
        </div>

        <table className="tw-w-full tw-border tw-border-blueGray-200">
          <thead>
            <tr>
              <th />
              <th className={thClass}>Description</th>
              <th className={thClass}>Review status</th>
              <th className={thClass}>Clinical significance</th>
              <th className={thClass}>Origin</th>
              <th className={thClass}>Method</th>
              <th className={thClass}>References</th>
            </tr>
          </thead>
          <tbody>
            {(accessions || []).map((x) => (
              <AccessionRow accession={x} key={x.id} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

ClinvarModal.propTypes = {
  cnv: PropTypes.instanceOf(StructuralVariant).isRequired,
  clinvarInformation: PropTypes.shape({
    variation_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    review_status: PropTypes.string,
    review_stars: PropTypes.number,
    num_submissions: PropTypes.number,
    names: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    num_submitters: PropTypes.number,
    last_evaluation: PropTypes.number,
    accessions: PropTypes.arrayOf(
      PropTypes.shape({ accession_id: PropTypes.string })
    ),
    clinical_significance: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default ClinvarModal;
